module.exports = __webpack_public_path__ + "static/media/puestaDelSol.483425a2.webp";